var _linearGradient, _linearGradient2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ffe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#f0fff4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 291.529,
    y2: 127.582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b59c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#SVGID_1_)",
    r: 256
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m260.814 201.283 134.668-87.401h-278.966l134.661 87.401c2.88 1.857 6.775 1.857 9.637 0zm-4.814 36.952c-44.082 0-79.941 35.859-79.941 79.941s35.859 79.941 79.941 79.941 79.941-35.859 79.941-79.941-35.859-79.941-79.941-79.941zm35.529 88.824h-26.647v26.647c0 4.91-3.973 8.882-8.882 8.882s-8.882-3.973-8.882-8.882v-26.647h-26.647c-4.91 0-8.882-3.973-8.882-8.882s3.973-8.882 8.882-8.882h26.647v-26.647c0-4.91 3.973-8.882 8.882-8.882s8.882 3.973 8.882 8.882v26.647h26.647c4.91 0 8.882 3.973 8.882 8.882s-3.972 8.882-8.882 8.882zm-186.529-199.476v137.299c0 14.694 11.953 26.647 26.647 26.647h30.434c11.639-40.948 49.29-71.059 93.919-71.059-5.17 0-10.175-1.483-14.495-4.285zm165.486 88.603c-4.311 2.802-9.316 4.285-14.486 4.285 44.629 0 82.28 30.111 93.919 71.059h30.434c14.694 0 26.647-11.953 26.647-26.647v-137.3z",
    fill: "url(#SVGID_2_)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8c1b0f4b651175d3dae2078d41fccc37.svg";
export { ForwardRef as ReactComponent };